import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DFCActiveCampaignTags } from 'src/app/models/ActiveCampaignModels';
import { UserService } from 'src/app/services/user.service';
import { ViewportService } from 'src/app/services/viewport.service';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@Component({
    selector: 'price-tracking-modal',
    templateUrl: './price-tracking-modal.component.html',
    styleUrl: './price-tracking-modal.component.css',
})
export class PriceTrackingModalComponent implements OnInit, OnDestroy {
    @Input() visible = false;
    @Output() onClose = new EventEmitter<void>();

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public viewport: ViewportService,
        public userService: UserService,
        public toast: ToastrService,
    ) {}

    ngOnInit() {}
    ngOnDestroy(): void {}

    hide() {
        this.onClose.emit();
    }

    close() {
        this.ref.close();
    }

    clickJoin() {
      const tagToAdd = DFCActiveCampaignTags.INTERESTED_IN_PRICE_DROP_TRACKING;
    
      this.userService
        .getUserACTags()
        .pipe(
          map(res => res.tags.map(t => Number(t)).includes(tagToAdd)),
          tap(hasTag => {
            if (hasTag) {
              this.toast.error('You are already on the price tracking waitlist');
            }
          }),
          filter(hasTag => !hasTag),
          switchMap(() => this.userService.updateACTag(tagToAdd)),
          tap(() => {
            this.toast.success('You are now on the price tracking waitlist');
          }),
          catchError(() => {
            this.toast.error('Error updating your price tracking waitlist status');
            return EMPTY;
          })
        )
        .subscribe();
    }
      
}
